import React from "react";

import { useI18n } from "Hooks";
import { ToddleIcon } from "SvgComponents";
import UserMenuButton from "AppComponents/UserMenuButton";

import classes from "./TopHeader.scss";
import { logoutUser } from "Login/modules/LoginModule";

const Header = () => {
  const { t } = useI18n();

  return (
    <div className={classes.container}>
      <div className={classes.greetingComponent}>
        <div className={classes.toddleIcon}>
          <ToddleIcon />
        </div>
        <div className={classes.detailContainer}>
          <h4>{t(`common:home`)}</h4>
        </div>
      </div>
      <div className={classes.rightMenu}>
        <UserMenuButton onLogout={logoutUser} isOnboarding={true} />
      </div>
    </div>
  );
};

export default Header;
